import React from 'react';
import { Col, Nav } from 'react-bootstrap';
import { Select } from 'components/partials/Fields/FormikSelect';
import AuctionRules from 'components/Auctions/AuctionRules';
import { Facility } from 'types/Facility';

interface AuctionTabsProps {
    facility: Facility
    renderAuctionTiles: (type: string) => React.ReactNode
    selectedOnlineAuctionType: string
    setSelectedOnlineAuctionType: (type: string) => void
    currentTab: string
    setCurrentTab: (tab: string) => void
}

const AuctionTabs: React.FC<AuctionTabsProps> = ({
    facility,
    renderAuctionTiles,
    selectedOnlineAuctionType,
    setSelectedOnlineAuctionType,
    currentTab,
    setCurrentTab,
}) => {
    const handleOnlineAuctionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const { value } = event.target;
        setSelectedOnlineAuctionType(value);
    };

    return (
        <>
            <Nav variant="tabs" className="mb-3">
                <Nav.Item className="flex-1">
                    <Nav.Link
                        className="top-nav__tab"
                        active={currentTab === 'online-auctions'}
                        onClick={() => setCurrentTab('online-auctions')}
                    >
                        ONLINE AUCTIONS
                    </Nav.Link>
                </Nav.Item>
                {facility.type_id !== 2 && (
                    <Nav.Item className="flex-1">
                        <Nav.Link
                            className="top-nav__tab"
                            active={currentTab === 'live-auctions'}
                            onClick={() => setCurrentTab('live-auctions')}
                        >
                            LIVE AUCTIONS
                        </Nav.Link>
                    </Nav.Item>
                )}
                <Nav.Item className="flex-1">
                    <Nav.Link
                        className="top-nav__tab"
                        active={currentTab === 'auction-rules'}
                        onClick={() => setCurrentTab('auction-rules')}
                    >
                        AUCTION RULES
                    </Nav.Link>
                </Nav.Item>
            </Nav>
            {currentTab === 'online-auctions' && (
                <>
                    <Col md={6}>
                        <Select
                            formik={false}
                            variant="info"
                            value={selectedOnlineAuctionType}
                            onChange={handleOnlineAuctionChange}
                            className="mb-3"
                        >
                            <option value="1">Active Auctions</option>
                            <option value="2">Upcoming Auctions</option>
                        </Select>
                    </Col>
                    <Col md={12} className="d-flex flex-column justify-content-center align-items-center">
                        {selectedOnlineAuctionType === '1' ? (
                            renderAuctionTiles('auctions')
                        ) : (
                            renderAuctionTiles('auctions_coming_soon')
                        )}
                    </Col>
                </>
            )}
            {currentTab === 'live-auctions' && renderAuctionTiles('auctions_live')}
            {currentTab === 'auction-rules' && <AuctionRules />}
        </>
    );
};

export default AuctionTabs;